enum TipoLancamento {
    Sangria,
    Reforco,
    Parcela,
}

export default TipoLancamento;
